// extracted by mini-css-extract-plugin
export var planCard = "_v2-0";
export var planList = "_v2-1";